// External libraries
import React from 'react';
// @ts-expect-error untyped import
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { PHONE_TYPES } from './constants';
import { validatePhoneType } from './utils';
import type { InputOnBlurChange, InputOnChange, InputOnFocus } from '@/types';
import type { FormState } from '@/store/models/form/types';

// For some reason we spread phoneType in props instead of passing the obj.
type PhoneType = FormState['phoneType'];

interface PhoneTypeProps extends PhoneType {
  blurHandler?: InputOnBlurChange;
  canDialingCodeChange: boolean;
  changeHandler: InputOnChange;
  disabled?: boolean;
  focusHandler?: InputOnFocus;
}

export const PhoneType = (props: PhoneTypeProps): JSX.Element => {
  const { canDialingCodeChange, ...propsToSpread } = props;
  const theme = features.get('rebrandFormFieldsTheme');

  return (
    <FloatingLabelSelect
      data-testid="phoneType"
      focusedClassName="is-focused"
      id="phoneType"
      isRightRadiusSquared={!canDialingCodeChange}
      label={getContent('fieldLabels.phoneType')}
      name="phoneType"
      required={true}
      selectOptions={PHONE_TYPES.map(type => ({
        text: getContent(`phoneTypes.${type.toLowerCase()}`),
        value: type,
      }))}
      theme={theme}
      validationFn={validatePhoneType}
      {...propsToSpread}
    />
  );
};
